import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  Url: string;

  constructor(public http: HttpClient) {
    this.Url = GlobalConstants.apiURL;;
  }


  public Registrar(DatosUsuario: any) {
    let json = JSON.stringify(DatosUsuario);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/register', json, { headers: headers }));
  }
  public Verficar(CrypMail: any) {
    let json = JSON.stringify(CrypMail);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/verify', params, { headers: headers }));
  }

  public IniciaSession(DatosUsuario: any) {
    let json = JSON.stringify(DatosUsuario);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/login', params, { headers: headers }));
  }

  public RecuperarPassword(DatosUsuario: any) {
    let json = JSON.stringify(DatosUsuario);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/recover', params, { headers: headers }));
  }
  public ActualizaPassword(DatosUsuario: any) {
    let json = JSON.stringify(DatosUsuario);
    let params = json;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return lastValueFrom(this.http.post(this.Url + '/updatePass', params, { headers: headers }));
  }

  public async GuestToken(): Promise<void> {
    // La API establece el token como cookie httpOnly en la respuesta
    await lastValueFrom(this.http.get<any>(this.Url + '/guest-token', { withCredentials: true }));
  }

}
